import axios from '@/libs/api.request';

export const getProduceList = ({ soed, unso, kw, devno, start, end, page, perPage }) => {
  const data = {
    soed,
    unso,
    kw,
    devno,
    start,
    end,
    page,
    perPage
  };
  return axios.request({
    url: 'produce/list',
    data,
    method: 'post'
  });
};
export const getProduceExcel = ({ soed, unso, kw, devno, start, end }) => {
  const data = {
    soed,
    unso,
    kw,
    devno,
    start,
    end
  };
  return axios.request({
    url: 'produce/toexcel',
    data,
    responseType: 'blob',
    method: 'post'
  });
};

export const getProduceMList = () => {
  return axios.request({
    url: 'produce/list/m',
    method: 'get'
  });
};

export const getProducePotList = (pdId) => {
  return axios.request({
    url: 'produce_pot/list/' + pdId,
    method: 'get'
  });
};

export const getKindList = () => {
  return axios.request({
    url: 'produce/kind/list',
    method: 'get'
  });
};

export const getPotKindList = () => {
  return axios.request({
    url: 'produce_pot/kind/list',
    method: 'get'
  });
};

export const getProduce = (id) => {
  return axios.request({
    url: 'produce/' + id,
    method: 'get'
  });
};

export const addProduce = (kind, pdNo, pnDate, pnWeek, fId, pnNum, batchNo,
                           fmNo, note) => {
  const data = {
    kind,
    'pd_no': pdNo,
    'pn_date': pnDate,
    'pn_week': pnWeek,
    'f_id': fId,
    'pn_num': pnNum,
    'batch_no': batchNo,
    'fm_no': fmNo,
    note
  };
  return axios.request({
    url: 'produce/add',
    data,
    method: 'post'
  });
};

export const deleteProduce = (id) => {
  return axios.request({
    url: 'produce/' + id,
    method: 'delete'
  });
};

export const modifyProduce = (id, kind, pdNo, pnDate, pnWeek, fId, pnNum,
                              batchNo, fmNo, note) => {
  const data = {
    kind,
    'pd_no': pdNo,
    'pn_date': pnDate,
    'pn_week': pnWeek,
    'f_id': fId,
    'pn_num': pnNum,
    'batch_no': batchNo,
    'fm_no': fmNo,
    note
  };
  return axios.request({
    url: 'produce/' + id,
    data,
    method: 'post'
  });
};

export const setProduce = (id, kind, pdWeight, pkgNum, pkgUnit, note, items) => {
  const data = {
    kind,
    'pd_weight': pdWeight,
    'pkg_num': pkgNum,
    'pkg_unit': pkgUnit,
    'note': note,
    items
  };
  return axios.request({
    url: 'produce/setp/' + id,
    data,
    method: 'post'
  });
};

export const maxNo = (date) => {
  const data = {
    date
  };
  return axios.request({
    url: 'produce/maxno',
    data,
    method: 'post'
  });
};

export const getProduceMixNameList = () => {
  return axios.request({
    url: 'produce_mix/name/list',
    method: 'get'
  });
};

export const getProduceMixList = (pdId, potNo) => {
  const data = {
    'pd_id': pdId,
    'pot_no': potNo
  };
  return axios.request({
    url: 'produce_mix/list',
    data,
    method: 'post'
  });
};

export const getProducePotCageList = (cageId) => {
  return axios.request({
    url: 'produce_pot/cage/list/' + cageId,
    method: 'get'
  });
};
